import BackRemovalModal from "./BackRemovalmodal";

export default BackRemovalModal;
